import { Selection, useConfigurio } from "@rromikas/configurio";
import ConfiguratorPreview from "pages/configurator/preview/preview";
import { FunctionComponent } from "react";
import PrimaryButton from "components/button";
import Button from "components/button";
import { useEditor } from "../editor";

interface SelectionsModalProps {
  onSave: (selections: Selection[]) => void;
  onClose: () => void;
}

const SelectionsModal: FunctionComponent<SelectionsModalProps> = ({ onSave, onClose }) => {
  const { configurator } = useEditor();
  const props = useConfigurio(configurator);
  return (
    <div className="fixed inset-0 bg-black/40 flex justify-end z-[1000]">
      <div className="bg-white max-w-[1100px] w-full overflow-auto h-full flex flex-col">
        <div className="flex justify-between mb-4 px-7 pt-7">
          <div className="text-xl font-bold">Initial Selections</div>
          <div className="flex space-x-3">
            <Button className="w-[120px]" onClick={onClose} variant="secondary">
              Cancel
            </Button>
            <PrimaryButton className="w-[120px]" onClick={() => onSave(props.selections)}>
              Save
            </PrimaryButton>
          </div>
        </div>
        <div className="h-0 flex-grow pl-7">
          <ConfiguratorPreview {...props} />
        </div>
      </div>
    </div>
  );
};

export default SelectionsModal;
